import { c as _c } from "react/compiler-runtime";
import { useStorefrontConfig } from '@ordering/providers/StorefrontConfig/StorefrontConfig';
import { useGetOrderType } from '@ordering/stores/OrderStore/hooks';
import { getSettlementMode, SettlementMode } from './getSettlementMode';
import { Mode } from './getSettlementMode';
export const useSettlementMode = () => {
  const $ = _c(3);
  const {
    paymentPolicy
  } = useStorefrontConfig();
  const orderType = useGetOrderType();
  const t0 = paymentPolicy?.settlement;
  const t1 = orderType?.collectionPoint;
  let t2;
  if ($[0] !== t0 || $[1] !== t1) {
    t2 = getSettlementMode(t0, t1);
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export const useIsOpenOrder = () => {
  return useSettlementMode().type === Mode.OpenOrder;
};